import React, { useState, useRef, useEffect } from 'react';
import Nav from "../../components/Nav";
import Body from "../../components/Body";
import { DataTable, DataTableExpandedRows, DataTableRowEvent, DataTableValueArray } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { usePrefundAudits } from "../../state/sampleAuditsExceptionsState";
import { useNavigate } from "react-router-dom";
import axios, { AxiosResponse } from 'axios';
import { TabView, TabPanel, TabPanelHeaderTemplateOptions } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import ReactDomServer from 'react-dom/server';
import { Badge } from 'primereact/badge';
import { authenticatedFetch } from '../../state/apiUtils';
import useHasRole from "../../hooks/validRolesHook";
import NotFound from "../Global/404NotFound";
import Loading from "../Global/loading";
import { getTenantPath } from '../Global/TenantPath';

export default function FindingList(props: any) {
    const toast = useRef<Toast>(null);

    const navigate = useNavigate();
    const auditPlanType = props.AuditPlanType;


    const [tabSummary, setTabSummary] = useState<any[]>([]);


    //Temporary for now since usePrefundAudits() is not working anymore
    //const {prefundStatus, prefundData, prefundError} = usePrefundAudits();

    // const onRowClick = (e: any) => {
    //     navigate(`/AuditForm/${e.data.MonthlyFundedLoanId}?audit_plan_id=${e.data.AuditPlanId}`);
    // }


    useEffect(() => {

        getTabSummary();
        //getAssignableUsers();
    }, [props.AuditPlanType]);

    
    const getTabSummary = () => {
        authenticatedFetch(
            `/FindingList/GetSummary`)
            .then(res => {
                var data = res;
                setTabSummary(data);
            });

    }

    const priorityTemplate = (item: any) => {
        return (<div>
            {item.Priority} {item.PriorityOrder == 0 ? <i className="pi pi-arrow-up" style={{ color: 'red' }} /> : ""}
        </div>)
    };


    const ValidationItems = (props: any) => {

    const assignPriorities = [
        "High",
        "Medium",
        "Low"
    ];
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [assign, setAssign] = useState<boolean>(false);
    const [assignableUsers, setAssignableUsers] = useState<any[]>([]);
    const [assignedTo, setAssignedTo] = useState<any>({
        userId: "",
        priority: "Medium"
    });
    const [error, setError] = useState<string>("");

    useEffect(() => {
        getData();
    }, [props.AreaResponsibleId]);

    // ── Clear selected user whenever item selection changes ──
    useEffect(() => {
        setAssignedTo({ userId: "", priority: "Medium" });
        setAssignableUsers([]);
        setError("");
    }, [selectedItems]);
    // ── END ──

    // ── Single close handler used by Cancel, X, and onHide ──
    const handleClose = () => {
        setAssign(false);
        setAssignedTo({ userId: "", priority: "Medium" });
        setAssignableUsers([]);
        setError("");
    };
    // ── END ──

    const assignInit = () => {
        const uniqueClients = selectedItems
            .map((item: any) => item.ClientBankName)
            .filter((value: any, index: number, self: any[]) => self.indexOf(value) === index)
            .filter((v: any) => v !== null && v !== undefined && v !== "");

        if (uniqueClients.length > 1) {
            toast.current?.show({
                severity: 'error',
                summary: 'Invalid Selection',
                detail: 'Selected loans belong to different Client Banks. Please select items from the same Client Bank.',
                life: 5000
            });
            return;
        }

        getAssignableUsers(uniqueClients[0]);
    }

    const getAssignableUsers = (clientBankName?: string) => {
        const args = clientBankName
            ? "?Client=" + encodeURIComponent(clientBankName)
            : "";

        authenticatedFetch("/FindingList/GetAssignableUsers" + args)
            .then(res => {
                setAssignableUsers(res);
                setAssign(true);
            });
    }

    const assignItems = () => {
        const selectedUser = assignableUsers.find((u: any) => u.UserId === assignedTo.userId);

        if (!selectedUser) {
            setError("Please select a user to assign.");
            return;
        }

        const userIsSystemAdmin = selectedUser.RoleName === 'System Administrator';

        if (!userIsSystemAdmin && selectedUser.ClientBankName) {
            const unMatch = selectedItems.filter(
                (f: any) => f.ClientBankName !== selectedUser.ClientBankName
            );

            if (unMatch.length > 0) {
                setError(
                    "Assigned Validator is not in the same Client Bank (" +
                    selectedUser.ClientBankName +
                    ") as the Loan. Ensure that all selected item(s) have the same Client Bank in order to assign these items to this selected Validator."
                );
                return;
            } else {
                setError("");
            }
        } else {
            setError("");
        }

        let param = {
            UserId: assignedTo.userId,
            Priority: assignedTo.priority,
            AreaResponsibleId: props.AreaResponsibleId,
            AuditReviewIds: selectedItems.map((m: any) => m.AuditFindingId)
        }

        authenticatedFetch("/FindingList/AssignItems", {
            method: "POST",
            body: JSON.stringify(param),
            headers: { "Content-Type": "application/json" }
        }).then(res => {
            getData();
            // ── Clear all state after successful submit ──
            setAssign(false);
            setSelectedItems([]);
            setAssignedTo({ userId: "", priority: "Medium" });
            setAssignableUsers([]);
            setError("");
            // ── END ──
            getTabSummary();
            toast.current?.show({
                severity: 'success',
                summary: 'Confirmed',
                detail: 'Items has been successfully assigned',
                life: 3000
            });
        });
    }

    const isQCAuditor = useHasRole(['QC Auditor']).hasRoles;

    // ── Cancel now uses handleClose ──
    const assignActions = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={handleClose} className="p-button-text" />
            <Button label="Submit" icon="pi pi-check" onClick={() => assignItems()} autoFocus />
        </div>
    );

    const auditFindingView = (item: any) => {
        return (<div className="linkButton"
            //onClick={() => navigate(`/AuditView/View?auditReviewId=${item.AuditReviewId}&auditFindingId=${item.AuditFindingId}&Role=QC VALIDATOR`)}
            //The below code changes for Multi tenant
            onClick={() => navigate(`${getTenantPath('AuditView/View')}?auditReviewId=${item.AuditReviewId}&auditFindingId=${item.AuditFindingId}&Role=QC VALIDATOR`)}
        > {item.RecordName}
        </div>)
    };

    const auditFindingViewForQCAuditor = (item: any) => {
        return (<div className="linkButton"
            //onClick={() => navigate(`/AuditView/View?auditReviewId=${item.AuditReviewId}&auditFindingId=${item.AuditFindingId}`)}
            onClick={() => navigate(`${getTenantPath('AuditView/View')}?auditReviewId=${item.AuditReviewId}&auditFindingId=${item.AuditFindingId}`)}
        > {item.RecordName}
        </div>)
    };

    const QCAuditorHeader = (
        <div className="table-header">
        </div>
    )

    const header = (
        <div className="table-header">
            {props.AreaResponsibleId != '00000000-0000-0000-0000-000000000000' ?
                <Button className='smallButton' disabled={selectedItems.length == 0} onClick={() => assignInit()}>Re-assign Item(s)</Button>
                : ""
            }
            {/* ── onHide now uses handleClose ── */}
            <Dialog header="QC Validator Assignment" visible={assign} style={{ width: '400px' }} onHide={handleClose} footer={assignActions}>
                <div className="mt-2 grid">
                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">Assign selected item(s) to </label>
                        <Dropdown
                            value={assignedTo.userId}
                            onChange={(e) => setAssignedTo((s: any) => { return { ...s, userId: e.value } })}
                            optionLabel='FullName'
                            optionValue='UserId'
                            options={assignableUsers}
                            className="w-full"
                        />
                    </div>
                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">Priority</label>
                        <Dropdown
                            value={assignedTo.priority}
                            onChange={(e) => setAssignedTo((s: any) => { return { ...s, priority: e.value } })}
                            options={assignPriorities}
                            className="w-full"
                        />
                    </div>
                    {error != "" ?
                        <div className="col-12 mb-2" style={{ color: "Red" }}>
                            {error}
                        </div>
                        : ""
                    }
                </div>
            </Dialog>
        </div>
    );

    const getData = () => {
        var param = {
            AreaResponsibleId: props.AreaResponsibleId
        }
        authenticatedFetch(
            `/FindingList/GetAreaItems`, {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then(res => {
                var data = res;
                setData(data);
            });
    }

    return (
        <div>
            <DataTable value={data} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditFindingId" loading={loading} scrollHeight='56vh' emptyMessage="No Findings"
                alwaysShowPaginator={false}
                selectionMode={isQCAuditor ? null : 'multiple'}
                selection={selectedItems!}
                onSelectionChange={(e: any) => setSelectedItems(e.value)}
                header={isQCAuditor ? QCAuditorHeader : header}
            >
                {isQCAuditor || props.AreaResponsibleId == '00000000-0000-0000-0000-000000000000' ?
                    <Column headerStyle={{ width: '3rem' }}></Column>
                    :
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                }
                <Column field="AuditPlanType" header="Audit Plan" sortable filter />
                <Column field="RecordName" header="Name" body={isQCAuditor ? auditFindingViewForQCAuditor : auditFindingView} sortable filter />
                <Column field="QcassignedTo" header="QC Auditor" sortable filter />
                <Column field="ValidatorAssignedTo" header="Validator" sortable filter />
                <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                <Column field="CurrentAssignment" header="Waiting Response From" sortable filter />
                <Column field="FindingDate" header="Date Assigned" sortable filter />
                <Column field="LoanName" header="Loan Name" sortable filter />
                <Column field="ClientBankName" header="Client Bank" sortable filter />
                <Column field="DefectDetail" header="Detail" sortable filter />
                <Column field="SeverityRating" header="Severity" sortable filter />
                <Column field="DefectName" header="Defect Name" sortable filter />
                <Column field="DefectCategory" header="Defect Category" sortable filter />
                <Column field="DefectSubCategory" header="Defect Sub Category" sortable filter />
            </DataTable>
        </div>
    );
}



    const tabHeader = (options: TabPanelHeaderTemplateOptions, header: string, subHeader: string, item: number) => {
        return (
            <button type="button" onClick={options.onClick} className={options.className} style={{ borderWidth: "0px", marginLeft: "0px" }}>
                <div className="block font-bold">
                    <Badge value={item ? item : 0} className={"mb-2 " + (item == undefined || item == 0 ? ' badge-zero-value ' : '')}></Badge><br />{header}<br />
                    {subHeader}

                    {/* {subHeader ? subHeader : '\u00A0'}
                    <div className="block mt-2">{detail} item(s)</div> */}
                </div>
            </button>
        )
    }

    let { hasRoles, isLoading } = useHasRole(['Account Administrator', 'Account Manager', 'QC Admin', 'QC Manager', 'QC Auditor', 'System Administrator'])

    if (isLoading) {
        return <Loading />
    }
    else if (!hasRoles) {
        return NotFound();
    }

    return (
        <div>
            <Nav />

            <Body>
                <div className='auditTable'>
                    <Toast ref={toast} position="bottom-center" />

                    <h1>Findings List</h1>
                    <TabView scrollable>
                        {
                            tabSummary.map((m: any) => {
                                return (
                                    <TabPanel  headerTemplate={(o) => tabHeader(o, m.AreaResponsibleName, "", m.MediumPriorityCount + m.LowPriorityCount + m.HighPriorityCount)}>
                                        <ValidationItems AreaResponsibleId={m.AreaResponsibleId} />
                                    </TabPanel>
                                )
                            })
                        }

                    </TabView>
                </div>

            </Body>
        </div>
    )
}
